// import React from "react";

// export const Header = (props) => {
//   return (
//     <header id="header">
//       <div className="intro">
//         <div className="overlay">
//           <div className="container">
//             <div className="row">
//               <div className="col-md-8 col-md-offset-2 intro-text">
//                 <h1
//                 // style={{
//                 //   width: "100%",
//                 //   fontSize: "60px",
//                 //   whiteSpace: "nowrap",
//                 //   overflow: "visible",
//                 //   textTransform: "none",
//                 // }}
//                 >
//                   {props.data ? props.data.title : "Loading"}
//                   <span></span>
//                 </h1>
//                 <p>{props.data ? props.data.paragraph : "Loading"}</p>
//                 <a href="#about" className="btn btn-custom btn-lg page-scroll">
//                   Learn More
//                 </a>{" "}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// };

import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <p className="hero-kicker">CradleAI</p>
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
                <div className="hero-actions">
                  <a href="#services" className="btn btn-custom btn-lg page-scroll">
                    Explore Product
                  </a>
                  <a href="#about" className="hero-secondary-link page-scroll">
                    Our Vision
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
